const app = {

    state: {
      login_mobile:'',
    },
  
    mutations: {
  
      SET_LOGIN_MOBILE: (state, val) => {
        state.login_mobile =val
      },
    },
    actions: {
        SetLoginMobile({ commit, state },mobile){
          commit('SET_LOGIN_MOBILE', mobile)
        },

    },
    getters: {
        GetLoginMobile (state) {
            return state.login_mobile ;
        }
    }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js